import { render, staticRenderFns } from "./work.vue?vue&type=template&id=6e39572c&"
import script from "./work.vue?vue&type=script&lang=ts&"
export * from "./work.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports